/* eslint-disable angular/component-name */
/* globals d3 */
angular.module('zc.zenclerkS')

  .component('behaviorVisualizer', {
    templateUrl: '/templates/zenclerk_s/directives/behavior_visualizer/behavior_visualizer.html',
    bindings: {
      behaviorData: '<'
    },
    controller($element, $scope, $state, $window, $interval, $timeout, $sce, $rootScope, Behavior) {
      const vm = this;
      const SINGLE_FRAME_MS = 50;

      let currentData;
      let showCursor;

      let cursor;
      let svgContainer;
      let viewFrame;

      vm.Behavior = Behavior;
      vm.Behavior.current.speedFactor = 1;
      vm.scaleFactor = 1;
      vm.time = {};

      vm.setSpeed = setSpeed;
      vm.goToNext = goToNext;
      vm.jumpToPosition = jumpToPosition;
      vm.togglePlay = togglePlay;
      vm.trustCaptureUrl = url => $sce.trustAsResourceUrl(url);

      vm.singleFrameMs = () => SINGLE_FRAME_MS * vm.Behavior.current.speedFactor;

      vm.normalizeTime = time => (time - vm.time.startPosition) / vm.time.totalTime * 100;

      vm.normalizePosition = pos => pos * vm.scaleFactor;

      vm.getClosest = () => _.filter(vm.behaviorData.data, d => Math.abs(vm.time.currentPosition - d.time) < vm.singleFrameMs())[0];

      vm.$onInit = () => {
        if(!vm.behaviorData.data.length) {
          return vm.goToNext();
        }

        //let controlsHeight = $element.find('.playback-controls').height();
        let controlsHeight = 63;
        let totalHeight = $element.find('.visualize-view').height();
        $element.find('.visualize-wrapper').height(totalHeight - controlsHeight);
        $element.find('.visualize-view').height();

        $scope.$on('$destroy', () => {
        // Make sure that the interval is destroyed too
          $interval.cancel(vm.interval);
          $timeout.cancel(vm.timeout);
        });

        vm.time.startPosition = _.minBy(vm.behaviorData.data, d => d.time).time;
        vm.time.endPosition = _.maxBy(vm.behaviorData.data, d => d.time).time;
        vm.time.totalTime = vm.time.endPosition - vm.time.startPosition;
        vm.time.currentPosition = vm.time.startPosition;

        initializeView();
      };

      function setSpeed(factor) {
        vm.Behavior.current.speedFactor = factor;
      }

      function initializeView() {
        showCursor = vm.behaviorData.device === 'pc';

        svgContainer = d3.select('.visualize-area-behavior').append('svg');

        vm.captureUrl = vm.behaviorData.url;

        viewFrame = svgContainer.selectAll('rect.view-frame')
          .data([vm.behaviorData.data[0]])
          .enter()
          .append('rect')
          .attr('class', 'view-frame')
          .attr('x', 0)
          .attr('y', 0)
          // TODO: window might not be defined!!!!!!
          .attr('width', d => d.window.Width || 100)
          .attr('height', d => d.window.Height || 100)
          .attr('stroke', 'red')
          .attr('fill', 'none')
          .attr('opacity', 0);

        // do not show on
        cursor = svgContainer.append('g')
          .attr('class', 'cursor')
          .attr('transform', 'translate(0, 0)')
          .attr('opacity', '0');

        if(showCursor) {
          cursor.append('image')
            .attr('class', 'cursor-inner')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', 22)
            .attr('height', 32)
            .attr('xlink:href', '/assets/visualizer/cursor32.png');
        } else {
          cursor.append('circle')
            .attr('class', 'cursor-inner')
            .attr('cx', 0)
            .attr('cy', 0)
            .attr('r', 20)
            .attr('fill', 'rgba(255,255,0,0.5)');
        }

        vm.Behavior.current.event = currentData;

        // delay playing so that iframe loads
        vm.timeout = $timeout(() => {
          vm.Behavior.current.isPlaying = true;
          // hackish - do this because first frame rendering might take some
          // time
          $timeout(() => {
            cursor.attr('opacity', 1);
            viewFrame.attr('opacity', 1);
          }, 700);
          vm.interval = $interval(update, SINGLE_FRAME_MS);
        }, 2000);
      }


      function update() {
        if(!Behavior.current.isPlaying) return;

        vm.time.currentPosition += vm.singleFrameMs();
        if(vm.time.currentPosition > vm.time.endPosition) {
          Behavior.current.isPlaying = false;
          vm.goToNext();
          $interval.cancel(vm.interval);
          return;
        }

        Behavior.current.playTime = vm.time.currentPosition;
        currentData = vm.getClosest();

        if(!currentData) {
        // fade the cursor out unless something changed
          if(!showCursor) {
            cursor.attr('opacity', function() { return d3.select(this).attr('opacity') - 0.05 });
          }

          // since there was no data for this frame, return
          return;
        }

        // TODO: dry with above
        if(!showCursor) {
          if(currentData.event && currentData.event.mouse) {
            cursor.attr('opacity', 1);
          } else {
            cursor.attr('opacity', function() { return d3.select(this).attr('opacity') - 0.05 });
          }
        }

        vm.Behavior.current.event = currentData;
        vm.height = vm.behaviorData.data[0].height;
        vm.scrollWidth = _.get(vm, 'behaviorData.data[0].window.Width') || vm.scrollWidth;
        //vm.scrollWidth = vm.behaviorData.data[0].window.Width;

        if(currentData.scroll) {
          vm.mouseX += currentData.scroll.dX;
          vm.mouseY += currentData.scroll.dY;
          vm.scrollX = currentData.scroll.X;
          vm.scrollY = currentData.scroll.Y;
          //$scope.scrollWidth = $scope.currentEvent.scroll.width
          //$scope.scrollHeight = $scope.currentEvent.scroll.height
          vm.scrollWidth = currentData.window.Width;
          vm.scrollHeight = currentData.window.Height;
        }

        if(currentData.gesture) {
          if(currentData.gesture.type === 'pinchout' || currentData.gesture.type === 'pinchin') {
            createPinch();
          } else {
            createOtherGesture();
          }
        }

        if(currentData.event && currentData.event.click) {
          createClick();
        }

        cursor.transition()
          .duration(50)
          .attr('transform', function(d) {
            if(!currentData.mouse) {
              return d3.select(this).attr('transform');
            }

            let x = currentData.mouse.screenX;
            let y = currentData.mouse.screenY;
            return `translate(${x}, ${y})`;
          });

        if(currentData.window) {
          let anim = viewFrame.transition()
            .duration(50)
            .attr('width', currentData.window.Width)
            .attr('height', currentData.window.Height);

          if(currentData.scroll) {
            anim
              .attr('x', currentData.scroll.X)
              .attr('y', currentData.scroll.Y);
          }
        }

        d3.select('.visualize-area')
          .transition()
          .duration(50)
          .tween('scrollTopTween', scrollTopTween(vm.scrollY))
          .tween('scrollLeftTween', scrollLeftTween(vm.scrollX));
        d3.select('.iframe-wrapper iframe')
          .transition()
          .duration(50)
          .tween('scrollTopTween', scrollTopTween(vm.scrollY))
          .tween('scrollLeftTween', scrollLeftTween(vm.scrollX));
      }

      function goToNext() {
      // TODO: there is no next in this way in zenclerk_s
      //Behavior.current.isPlaying = false
      //nextSid = Behavior.getNextHistorySid(vm.behaviorData._sid)
      //if nextSid
      //  $scope.timeout = $timeout () ->
      //    $state.go 'viz.site.session.player', {apikey: Behavior.current.apikey, usid: Behavior.current.usid, sid: nextSid}
      //  , 3000
      }

      function jumpToPosition(event) {
        let width = $(event.target).width();
        let offset = event.offsetX;
        let percentage = offset / width;
        vm.time.currentPosition = vm.time.startPosition + (vm.time.endPosition - vm.time.startPosition) * percentage;
      }


      function togglePlay() {
        if(!vm.Behavior.current.isPlaying) {
          $interval.cancel(vm.interval);
          vm.interval = $interval(update, SINGLE_FRAME_MS);
        }

        // TODO: remove all clicks

        vm.Behavior.current.isPlaying = !vm.Behavior.current.isPlaying;
      }


      function createPinch() {
        let position = {};
        let direction = currentData.gesture.type;

        if(direction === 'pinchin') {

          position.sx1 = currentData.gesture.px + currentData.gesture.dx || -99;
          position.sy1 = currentData.gesture.py + currentData.gesture.dy || -99;
          position.sx2 = currentData.gesture.px - currentData.gesture.dx || -99;
          position.sy2 = currentData.gesture.py - currentData.gesture.dy || -99;
          position.ex1 = currentData.gesture.px || -99;
          position.ey1 = currentData.gesture.py || -99;
          position.ex2 = currentData.gesture.px || -99;
          position.ey2 = currentData.gesture.py || -99;

        } else if(direction === 'pinchout') {

          position.sx1 = currentData.gesture.px || -99;
          position.sy1 = currentData.gesture.py || -99;
          position.sx2 = currentData.gesture.px || -99;
          position.sy2 = currentData.gesture.py || -99;
          position.ex1 = currentData.gesture.px + currentData.gesture.dx || -99;
          position.ey1 = currentData.gesture.py + currentData.gesture.dy || -99;
          position.ex2 = currentData.gesture.px - currentData.gesture.dx || -99;
          position.ey2 = currentData.gesture.py - currentData.gesture.dy || -99;

        }

        let pinch1 = svgContainer.insert('circle', '.cursor')
          .attr('class', 'pinch')
          .attr('cx', position.sx1)
          .attr('cy', position.sy1)
          .attr('r', 25)
          .attr('fill', 'blue')
          .attr('opacity', 0.5);

        let pinch2 = svgContainer.insert('circle', '.cursor')
          .attr('class', 'pinch')
          .attr('cx', position.sx2)
          .attr('cy', position.sy2)
          .attr('r', 25)
          .attr('fill', 'blue')
          .attr('opacity', 0.5);

        pinch1
          .transition()
          .duration(200)
          .attr('cx', position.ex1)
          .attr('cy', position.ey1)
          .transition()
          .duration(500)
          .attr('opacity', 0.3)
          .transition()
          .duration(2000)
          .attr('opacity', 0)
          .transition()
          .remove();

        pinch2
          .transition()
          .duration(200)
          .attr('cx', position.ex2)
          .attr('cy', position.ey2)
          .transition()
          .duration(500)
          .attr('opacity', 0.3)
          .transition()
          .duration(2000)
          .attr('opacity', 0)
          .transition()
          .remove();
      }

      function createOtherGesture() {
        let position = {};

        if(currentData.gesture) {
          position.sx = currentData.gesture.px - currentData.gesture.dx;
          position.sy = currentData.gesture.px - currentData.gesture.dx;
          position.ex = currentData.gesture.px;
          position.ey = currentData.gesture.py;
        } else {
          console.log('had no gesture');
        }

        svgContainer.insert('circle', '.cursor')
          .attr('class', 'click')
        // TODO there might not be gesture
          .attr('cx', position.sx)
          .attr('cy', position.sy)
          .attr('r', 25)
          .attr('fill', () => {
            switch (currentData.gesture.type) {
              case 'release':
              case 'swiperight':
              case 'swipeleft':
                return 'purple';
              case 'tap':
                return 'lime';
              default:
                return 'red';
            }
          })
          .attr('opacity', 0.5)
          .transition()
          .duration(200)
          .attr('cx', position.ex)
          .attr('cy', position.ey)
          .transition()
          .duration(500)
          .attr('opacity', 0.3)
          .transition()
          .duration(5000)
          .attr('opacity', 0)
          .transition()
          .remove();
      }

      function createClick() {
        svgContainer.insert('circle', '.cursor')
          .attr('class', 'click')
        // TODO there might not be mouse
          .attr('cx', currentData.mouse.screenX || -99)
          .attr('cy', currentData.mouse.screenY || -99)
          .attr('r', 25)
          .attr('fill', 'steelblue')
          .attr('opacity', 0.7)
          .transition()
          .duration(50)
          .attr('r', 30)
          .transition()
          .delay(100)
          .duration(500)
          .ease('sin')
          .attr('r', 10)
          .attr('opacity', 0.3)
          .transition()
          .duration(2000)
          .attr('opacity', 0)
          .transition()
          .remove();
      }


      // scrollTop and scrollLeft are arbitrary properties so custom
      // interpolator
      // http://stackoverflow.com/a/16353819
      function scrollTopTween(scrollTop) {
        return function() {
          let i = d3.interpolateNumber(this.scrollTop, scrollTop);
          return t => { this.scrollTop = i(t) };
        };
      }

      function scrollLeftTween(scrollLeft) {
        return function() {
          let i = d3.interpolateNumber(this.scrollLeft, scrollLeft);
          return t => { this.scrollLeft = i(t) };
        };
      }
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/behavior_visualizer/behavior_visualizer.js